/*!
 * Copyright 2026 - Swiss Data Science Center (SDSC)
 * A partnership between École Polytechnique Fédérale de Lausanne (EPFL) and
 * Eidgenössische Technische Hochschule Zürich (ETHZ).
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const RENKU_QUERY_PARAMS = {
  login: "renku_login",
  logout: "renku_logout",
  loginValue: "1",
} as const;

export const RENKU_USER_SIGNED_IN_COOKIE = "renku_user_signed_in";

export const LOGOUT_EVENT_TIMEOUT = 5_000; // 5 seconds

export const RENKU_USER_SIGNED_IN_COOKIE_TTL = 365 * 24 * 60 * 60 * 1000; // 1 year
